import styles from './style.module.scss';
import { Row, Col, Descriptions } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DeleteIcon, EditIcon } from 'icons';
import useEmergencyContacts from '../useEmergencyContacts';

const Single = ({ }) => {
  const { t } = useTranslation();
  const { singleItem } = useEmergencyContacts(false, false);
  const title = t('CONTATTI DI EMERGENZA');

  return (
    <div>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Link to={'delete'}>
              <Button
                icon={<DeleteIcon />}
                big
                iconMargin
                type={'red'}
                upperCase
              >
                {t('Cancella')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Insegna')}>
            {singleItem?.company?.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Nome')}>
            {singleItem?.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('Cognome')}>
            {singleItem?.surname}
          </Descriptions.Item>
          <Descriptions.Item label={t('Cellulare')}>
            {singleItem?.phone}
          </Descriptions.Item>
          <Descriptions.Item label={t('Priorità di contatto')}>
            {singleItem?.priority}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
